import styled from "styled-components";

export const Styles = styled.div`
    .project-page {
        .project-area {
            padding-top: 80px;

            @media (max-width: 767px) {
                padding-top: 40px;
            }
        }
    }
`;